import styled from 'styled-components';
import { Select } from 'antd';
import { P, fs, radius } from '../theme/tokens';

const Styled = styled(Select)`
  &.ant-select {
    width: 100%;
    min-width: 0;
    height: 42px;
    font-size: ${fs.sm}px;
  }
  &.ant-select .ant-select-selector {
    border-radius: ${radius.md}px;
    border-color: ${P.border};
    padding: 0 13px;
  }
  &.ant-select-focused .ant-select-selector {
    border-color: ${P.navy};
    box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.12);
  }
`;

export default function SearchSelect({ value, onChange, options, placeholder = 'Search or pick', ...rest }) {
  return (
    <Styled
      showSearch
      optionFilterProp="label"
      placeholder={placeholder}
      value={value === '' ? undefined : value}
      onChange={(v) => onChange(v ?? '')}
      options={options}
      notFoundContent="No matches"
      {...rest}
    />
  );
}
